import { render, staticRenderFns } from "./realTimeView.vue?vue&type=template&id=b03c0d5a&scoped=true"
import script from "./realTimeView.vue?vue&type=script&lang=js"
export * from "./realTimeView.vue?vue&type=script&lang=js"
import style0 from "./realTimeView.vue?vue&type=style&index=0&id=b03c0d5a&prod&lang=less&scoped=true"
import style1 from "./realTimeView.vue?vue&type=style&index=1&id=b03c0d5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b03c0d5a",
  null
  
)

export default component.exports